import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const saved = localStorage.getItem("cart");
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    setCartItems(prev => {
      const exists = prev.find(i => i.product_id === product.id);
      if (exists) return prev;
      return [...prev, {
        product_id: product.id,
        name: product.name,
        price: product.price,
        shipping: product.shipping,
        total: product.total,
        type: product.type,
        books_count: product.books_count,
        badge: product.badge
      }];
    });
    setIsCartOpen(true);
  };

  const removeFromCart = (product_id) => {
    setCartItems(prev => prev.filter(i => i.product_id !== product_id));
  };

  const clearCart = () => setCartItems([]);

  const cartCount = cartItems.length;
  const cartSubtotal = cartItems.reduce((sum, i) => sum + i.price, 0);
  const cartShipping = cartItems.reduce((sum, i) => sum + i.shipping, 0);
  const cartTotal = cartSubtotal + cartShipping;
  const hasPhysical = cartItems.some(i => i.type === "physical" || i.type === "physical_no_ship" || i.type === "membership");

  return (
    <CartContext.Provider value={{
      cartItems, cartCount, cartSubtotal, cartShipping, cartTotal, hasPhysical,
      addToCart, removeFromCart, clearCart,
      isCartOpen, setIsCartOpen
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
